// extracted by mini-css-extract-plugin
export var cardIcon = "_4d-4";
export var checkboxCard = "_4d-0";
export var checkboxCardSelected = "_4d-3";
export var disabled = "_4d-1";
export var outerBorder = "_4d-2";
export var spacerMedium = "_4d-7";
export var spacerSmall = "_4d-6";
export var spacerXsmall = "_4d-5";